import { Modal, Progress } from "antd";
import React, { useEffect, useState } from "react";
import Text from "../Text/Text";
import color from "../../resource/color";
import { syncCredit } from "../../datasource/CreditLimitDatasource";

interface Props {
  open: boolean;
  onClose: () => void;
  customerNo: string;
}

function ModalSync({ open, onClose, customerNo }: Props) {
  const [percent, setPercent] = useState(0);
  const companyCode = JSON.parse(localStorage.getItem("company")!);

  useEffect(() => {
    if (open) {
      setPercent(0);
      const startTime = Date.now();
      const interval = setInterval(() => {
        const elapsed = Date.now() - startTime;
        const newPercent = Math.min((elapsed / 3000) * 100, 100);
        setPercent(newPercent);

        if (newPercent >= 100) {
          clearInterval(interval);

          setTimeout(async () => {
            await syncCredit(companyCode?.companyCode, customerNo).then((res) => {
              if (res.success) {
                onClose();
              }
            });
          }, 300);
        }
      }, 30);

      return () => clearInterval(interval);
    }
  }, [open, onClose, customerNo]);

  return (
    <Modal
      width='300px'
      open={open}
      closable={false}
      centered
      footer={null}
      styles={{
        body: {
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
        },
      }}
    >
      <Progress
        size={55}
        type='circle'
        percent={percent}
        format={() => ""}
        strokeWidth={16}
        strokeColor={color.primary}
      />
      <Text
        fontFamily='IBM Plex Sans Thai'
        fontSize={20}
        fontWeight={700}
        style={{ marginTop: "20px" }}
      >
        รออัปเดตสักครู่
      </Text>
    </Modal>
  );
}

export default ModalSync;
